import { applyNodeChanges } from 'reactflow';


export const updateFlowNodes = (newNodes, oldNodes) => {
  const newState = applyNodeChanges(newNodes, oldNodes);

  return newState;
};
